const openModal = (modal) => {
  const open = document.querySelector('.payment_box_modal.open')
  if (open) { closeModal(open) }

  modal.classList.add('open')
}

const closeModal = (modal) => {
  modal.classList.remove('open')
}

window.novadaSelectPaymentMethod = function (input) {
  if (input.classList.contains('has_fields')) {
    // open modal with fields
    const modal = input.parentNode.querySelector('.payment_box_modal')
    if (modal) {
      openModal(modal)

      modal.querySelector('.payment_box_modal_content').addEventListener('click', (e) => {
        e.stopPropagation()
      })

      modal.querySelector('.payment_box_modal_content input[type="submit"]').addEventListener('click', (e) => {
        closeModal(modal)
      })

      modal.addEventListener('click', (e) => {
        e.preventDefault()
        closeModal(modal)
      })

      return
    }
  }

  const placeOrderButton = document.querySelector('button#place_order')
  if (placeOrderButton) {
    placeOrderButton.click()
  }
}
